import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';

@Component({
    selector: 'signin-redirect-callback',
    templateUrl: './signin-redirect-callback.component.html',
    styleUrls: ['./signin-redirect-callback.component.scss'],
    standalone: false
})
export class SigninRedirectCallbackComponent implements OnInit {

  constructor(private router: Router,
    private oauthService: OAuthServiceService) { }

  ngOnInit() {
    this.oauthService.checkAuth().subscribe({
      next: () => {
        sessionStorage.removeItem('signin_retry_done');
        this.router.navigate(['/']);
      },
      error: (err) => {
        console.error('signin-callback: checkAuth failed:', err);
        // Selbstheilung bei state-Mismatch: Die Anmeldung beim STS war erfolgreich
        // (SSO-Session existiert bereits). Ein frischer authorize-Versuch laeuft
        // daher ohne erneute Anmeldung durch und liefert einen konsistenten state.
        // Das Einmal-Flag verhindert eine Redirect-Schleife, falls auch der
        // zweite Versuch scheitert.
        if (!sessionStorage.getItem('signin_retry_done')) {
          console.warn('signin-callback: starte einmaligen Login-Retry');
          sessionStorage.setItem('signin_retry_done', '1');
          this.oauthService.doLogin();
        } else {
          sessionStorage.removeItem('signin_retry_done');
          this.router.navigate(['/']);
        }
      }
    });
  }
}
